import React from "react";
import ExperienceCard from "./ExperienceCard";

const experienceData = [
  {
    logo: "../amazon.png",
    title: "Software Development Engineer Intern",
    company: "Amazon - Finance Technology",
    location: "Bellevue, WA",
    duration: "Summer 2026",
    bullets: [
      "Designed and built an LLM-powered chatbot enabling non-technical users to create document extraction configuration for Nucleus, using AWS Bedrock, tool calling, React/TypeScript, Cloudscape, DynamoDB, S3, and Coral.",
      "Architected and implemented the solution end-to-end on top of existing Nucleus infrastructure, designing and developing a new Coral API and deploying the application to production for user adoption.",
      "Eliminated manual configuration steps and reduced onboarding time for new Nucleus use cases by 75%.",
    ],
  },
  {
    logo: "../motorola.png",
    title: "Embedded Software Engineering Intern",
    company: "Motorola Solutions, Inc.",
    location: "Plantation, FL",
    duration: "Summer 2024, Summer 2025",
    bullets: [
      "Worked on a feature team, utilizing Bitbucket and Jira to enhance Agile development workflows.",
      "Developed and deployed Python and Arduino firmware to drive a stepper motor for component stress testing, enabling durability tests capable of running thousands of cycles in collaboration with the Mechanical team.",
      "Resolved a critical radio failure issue by implementing a message queue within the logging thread, significantly reducing thread blocking and enhancing system stability.",
      "Implemented a suite of automated Vista autotest scripts to validate Unitization feature, improving test coverage and reliability.",
    ],
  },
  {
    logo: "../ibis.png",
    title: "Game Developer",
    company: "Ibis Network",
    location: "Remote",
    duration: "Jan 2019 - Jul 2023",
    bullets: [
      "Implemented a custom monetization system that generated hundreds in revenue.",
      "Developed a course management system with dynamic sorting features using Skript in Minecraft Java Edition.",
      "Designed various maps, a leveling system, UIs, and an in-game economy with user-friendliness as a priority.",
    ],
    note: "Additional note: While not a fully paid position, this is where I first developed my passion for coding and designing use-facing systems.",
  },
];

const Experience = () => {
  return (
    <div
      id="experience"
      className="bg-theme-default text-gray-800 py-4 px-4 sm:px-8"
    >
      <h2 className="text-4xl font-bold text-center mb-6">Experience</h2>
      <div className="flex flex-col gap-8 items-center">
        {experienceData.map((exp, index) => (
          <ExperienceCard
            key={index}
            {...exp}
            className="w-full sm:w-4/5 md:w-3/5"
          />
        ))}
      </div>
    </div>
  );
};

export default Experience;
